import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'app-notification-detail-dialog',
  templateUrl: './notification-detail-dialog.component.html',
  styleUrls: ['./notification-detail-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, DialogComponent],
})
export class NotificationDetailDialogComponent {
  // ── Inputs ──
  @Input() show: boolean = false;
  @Input() notification: any = null;
  @Input() canOpenConversation: boolean = false;
  @Input() isProposal: boolean = false;
  @Input() actionKey: string = '';
  @Input() selectedRoute: string | null = null;
  @Input() dateTimeLabel: string = '';
  @Input() sendingProposal: boolean = false;

  // ── Outputs ──
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateChat: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() startContact: EventEmitter<Event | undefined> = new EventEmitter<Event | undefined>();
  @Output() accessRoute: EventEmitter<Event | undefined> = new EventEmitter<Event | undefined>();
  @Output() proposalSent: EventEmitter<string> = new EventEmitter<string>();

  // ── Local proposal state ──
  acceptProposalOpen: boolean = false;
  proposalResponse: string = '';
  readonly MAX_PROPOSAL_RESPONSE_LENGTH: number = 150;

  // ── Computed getters ──

  get notificationType(): number {
    return Number(this.notification?.type) || 0;
  }

  get displayTitle(): string {
    return this.notification?.title || '';
  }

  get bodyHtml(): string {
    return this.notification?.safeBody
      || this.notification?.safeHtml
      || this.notification?.text
      || this.notification?.body
      || '';
  }

  get plainBody(): string {
    return this.notification?.text
      || this.notification?.body
      || '';
  }

  get hasActions(): boolean {
    return !!(this.notification?.data || this.notification?.originalData?.data);
  }

  get storedProposalResponse(): string {
    const storedResponse: unknown =
      this.notification?.proposalResponseText ??
      this.notification?.proposalResponse ??
      this.notification?.data?.proposalResponse ??
      this.notification?.data?.proposal_response ??
      this.notification?.originalData?.proposalResponse ??
      this.notification?.originalData?.proposal_response;

    return typeof storedResponse === 'string' ? storedResponse.trim() : '';
  }

  get hasStoredProposalResponse(): boolean {
    return this.storedProposalResponse.length > 0;
  }

  // ── Methods ──

  onClose(): void {
    this.resetProposalState();
    this.closed.emit();
  }

  onNavigateChat(event: Event): void {
    this.navigateChat.emit(event);
  }

  onStartContact(event?: Event): void {
    this.startContact.emit(event);
  }

  onAccessRoute(event?: Event): void {
    this.accessRoute.emit(event);
  }

  toggleAcceptProposal(): void {
    this.acceptProposalOpen = !this.acceptProposalOpen;
  }

  onSendProposal(): void {
    if (this.sendingProposal) return;
    this.proposalSent.emit(this.proposalResponse);
  }

  resetProposalState(): void {
    this.acceptProposalOpen = false;
    this.proposalResponse = '';
  }
}
